'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'wand-magic-sparkles';
var width = 576;
var height = 512;
var aliases = ["magic-wand-sparkles"];
var unicode = 'e2ca';
var svgPathData = 'M272-16l0 32 32 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-32 0 0 32c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-32-32 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l32 0 0-32c0-4.4 3.6-8 8-8s8 3.6 8 8zM478.1 23.5c-9.8-9.8-26.4-9.8-36.3 0L318.3 147 397 225.7 520.5 102.1c9.8-9.8 9.8-26.4 0-36.3l0 0-42.3-42.3zM55.5 409.9c-9.8 9.8-9.8 26.4 0 36.3l42.3 42.3 0 0c9.8 9.8 26.4 9.8 36.3 0L385.7 237 307 158.3 55.5 409.9zm375-397.7c16.1-16.1 42.8-16.1 58.9 0l42.3 42.3c16.1 16.1 16.1 42.8 0 58.9L145.5 499.8c-16.1 16.1-42.8 16.1-58.9 0L44.2 457.5c-16.1-16.1-16.1-42.8 0-58.9L430.5 12.2zM96 40l0 72 72 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-72 0 0 72c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-72-72 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l72 0 0-72c0-4.4 3.6-8 8-8s8 3.6 8 8zM472 320c4.4 0 8 3.6 8 8l0 72 72 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-72 0 0 72c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-72-72 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l72 0 0-72c0-4.4 3.6-8 8-8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWandMagicSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;